import { fetchJSON } from '@eb/http';

const AJAX_ACTION_URL = '/ajax/analytics/action';

//NB: Migrated from js-utils b/c it is used once
// Use postAnalyticsAction when you want to record analytics but stay on the same page
// records the action via AJAX so it is suboptimal for logging link clicks
export function postAnalyticsAction(action, dimensions, metrics) {
    if (!fetchJSON) {
        return;
    }
    fetchJSON(AJAX_ACTION_URL, {
        method: 'POST',
        body: JSON.stringify({
            action,
            dimensions,
            metrics,
        }),
    });
}

// NB: js-utils also had this -- need to see if this url is used/active
// const AJAX_EVENT_CLICK_URL = '/eventclick';
// function recordEventPageView(eid) {
//     if (!fetchEB) {
//         return;
//     }

//     fetchEB(AJAX_EVENT_CLICK_URL, {
//         method: 'POST',
//         body: { eid },
//     });
// }
